<content>
    <section id="big-modal" >
    <form [formGroup]="newForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div class="entry-4-modal calendar">
            <label>{{'mantenimientoDesignaciones.table.fecha' | translate}} *</label>
            <input [matDatepicker]="fechaDesignacion" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaDesignacion"
              (click)="fechaDesignacion.open()">
            <mat-datepicker #fechaDesignacion></mat-datepicker>
          </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoDesignaciones.table.etiquetador' | translate}} *</label>
            <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="newForm.get('etiquetador')" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'global.pais' | translate}} *</label>
            <app-filterable-list [itemsList]="paises" [selectedItem]="newForm.get('pais')"
                [disabled]="disabledPaises" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoDesignaciones.table.denominaciones' | translate}} *</label>
            <app-filterable-list [itemsList]="denominaciones" [selectedItem]="newForm.get('denominacion')"
                [disabled]="disabledDenominaciones" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <!-- <div class="entry-3">
            <label>{{'mantenimientoDesignaciones.table.campanya' | translate}} *</label>
            <app-filterable-list [itemsList]="campanyas" [selectedItem]="newForm.get('campanya')"
                [disabled]="disabledCampanyas">
            </app-filterable-list>
        </div> -->
        <div class="entry-4-modal select">
            <label>{{'global.cultivo' | translate}} *</label>
            <app-filterable-table [columns]="columns" [properties]="properties" [itemsList]="cultivos" [selectedItem]="newForm.get('cultivo')"
            [disabled]="disabledCultivos">
            </app-filterable-table>
        </div>
        <!-- <div class="entry-3">
            <label>{{'mantenimientoDesignaciones.table.marca' | translate}} </label>
            <input type="text" formControlName="marca" readonly>
        </div> -->
        <div class="entry-4-modal">
            <label>{{'mantenimientoDesignaciones.table.aforoDisponible' | translate}}
              ({{(this.newForm ? this.newForm.get('aforoDisponible')?.value : 0) | number : '1.2-2': defaultLanguage}}
              Kg)</label>
            <progress [ngClass]="{'exceeded': porcentajeAforoDisponible > 100 ||
              porcentajeAforoDisponible < 0}" [value]="porcentajeAforoDisponible" max="100"
              min="-1000"></progress><span>{{porcentajeAforoDisponible.toFixed(2)| number : '1.2-2': defaultLanguage}}%</span>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoDesignaciones.table.cantidad' | translate}} *</label>
            <input type="number" formControlName="cantidad">
        </div>
        <div class="entry-4-modal alignment-start">
            <input type="checkbox" id="etiqueta-digital-new-desig" formControlName="etiquetaDigital">
            <label for="etiqueta-digital-new-desig">{{'global.etiquetaDigital' | translate}}</label>
        </div>
        <div class="entry-4-modal alignment-start">
            <input type="checkbox" id="almacenes" formControlName="almacenes">
            <label for="almacenes">{{'mantenimientoDesignaciones.table.todos' | translate}}</label>
        </div>
        <!-- *ngIf="showAlmacenes" al div -->
        <div >
            <content *ngFor="let almacen of almacenes">
                <form>
                    <div class="entry-3">
                        <input type="text" readonly value="{{almacen.des}}">
                    </div>
                    <div class="entry-3">
                        <input type="checkbox" id="{{almacen.id}}" name="checkAlmacenes" (click)="addAlmacenes($event)">
                        <label for="{{almacen.id}}"></label>
                    </div>
                </form>
            </content>
        </div>
    </form>
    <footer class="button-bar-right">
        <button (click)="confirmarCapacidad()">{{'global.insertar' | translate}}</button>
    </footer>
    <div class="table-wrapper-bigger">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="icon"></th>
                        <th class="id">{{'mantenimientoDesignaciones.table.id' | translate}}</th>
                        <th class="date">{{'mantenimientoDesignaciones.table.fecha' | translate}}</th>
                        <th class="string">{{'mantenimientoDesignaciones.table.denominacion' | translate}}</th>
                        <th class="string">{{'mantenimientoDesignaciones.table.etiquetador' | translate}}</th>
                        <th class="string">{{'global.finca' | translate}}</th>
                        <th class="string">{{'mantenimientoDesignaciones.table.marca' | translate}}</th>
                        <th class="string">{{'mantenimientoDesignaciones.table.productor' | translate}}</th>
                        <th class="string">{{'mantenimientoDesignaciones.table.licencia' | translate}}</th>
                        <th class="string">{{'global.municipio' | translate}}</th>
                        <th class="number">{{'mantenimientoDesignaciones.table.aforo' | translate}}</th>
                        <th class="number">{{'mantenimientoDesignaciones.table.designado' | translate}}</th>
                        <th class="action"></th>
                    </tr>
                </thead>
                <tbody *ngFor="let designacion of designaciones">
                    <tr>
                        <td class="icon">
                            <i *ngIf="designacion.esEtqDigital" class="fa-solid fa-file fa-1x"
                              title="{{'global.etiquetaDigital' | translate}}"></i>
                        </td>
                        <td class="id">{{designacion.id}}</td>
                        <td class="date">{{designacion.fecha | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="string">{{designacion.desDenominacion}}</td>
                        <td class="string">{{designacion.desEtiquetador}}</td>
                        <td class="string">{{designacion.desFinca}}</td>
                        <td class="string">{{designacion.desMarca}}</td>
                        <td class="string">{{designacion.desProductor}}</td>
                        <td class="string">{{designacion.nLicencia}}</td>
                        <td class="string">{{designacion.desMunicipio}}</td>
                        <td class="number">{{designacion.aforoCultivo}}</td>
                        <td class="number">{{designacion.cantidad}}</td>
                        <th class="action">
                            <i class="far fa-trash-alt" app-click-stop-propagation (click)="askDelete(designacion)"
                            title="{{'titles.eliminar' | translate}}"></i>
                        </th>
                    </tr>
                </tbody>
                <tfoot *ngIf="!designaciones || (designaciones && designaciones.length < 1)">
                    <tr>
                        <td colspan="13">
                            {{ 'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <footer class="button-bar-right">
        <button (click)="close()">{{'global.cerrar' | translate}}</button>
    </footer>
    </section>
</content>
<div class="modal" *ngIf="capacidadModal">
    <div class="modal-content">
      <header>
        <h4>Capacidad superada</h4>
      </header>
      <content>
        <p>El aforo del cultivo se ha superado. ¿Desea continuar?</p>
      </content>
      <footer>
        <button class="secondary" (click)="capacidadModal = false">{{'global.cancelar' | translate}}</button>
        <button (click)="add()">{{'global.confirmar' | translate}}</button>
      </footer>
    </div>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
        </header>
        <content>
            <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
        </content>
        <footer>
            <button class="secondary" (click)="this.deleteModal = false">{{ 'global.cancelar' | translate }}</button>
            <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="etiquetaDigitalModal">
    <div class="modal-content" style="max-width: 30rem">
      <header>
        <h4>{{ 'global.etiquetaDigital' | translate }}</h4>
      </header>
      <content>
        <p [innerHTML]="'global.info.etiquetaDigital' | translate"></p>
      </content>
      <footer>
        <button class="secondary" (click)="etiquetaDigitalModal = false">{{'global.cancelar' | translate}}</button>
        <button (click)="add()">{{'global.confirmar' | translate}}</button>
      </footer>
    </div>
</div>
<app-toast *ngIf="mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
